// ----------------------------------------------------------------------

// Keys that should be preserved when clearing localStorage (e.g., during logout)
const PRESERVED_STORAGE_KEYS = ['zeta_cookie_consent'];

export function localStorageAvailable() {
  try {
    const key = '__some_random_key_you_are_not_going_to_use__';
    window.localStorage.setItem(key, key);
    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
}

export function localStorageGetItem(key: string, defaultValue = '') {
  const storageAvailable = localStorageAvailable();

  let value;

  if (storageAvailable) {
    value = localStorage.getItem(key) || defaultValue;
  }

  return value;
}

/**
 * Clears localStorage while preserving specified keys.
 * By default, preserves 'zeta_cookie_consent' to maintain user's cookie preferences across sessions.
 * @param additionalKeysToPreserve - Optional array of additional keys to preserve
 */
export function clearLocalStorageExcept(additionalKeysToPreserve: string[] = []) {
  if (!localStorageAvailable()) return;

  const keysToPreserve = [...PRESERVED_STORAGE_KEYS, ...additionalKeysToPreserve];

  // Save values of keys to preserve
  const preservedValues: Record<string, string | null> = {};
  keysToPreserve.forEach((key) => {
    preservedValues[key] = localStorage.getItem(key);
  });

  // Clear all localStorage
  localStorage.clear();

  // Restore preserved keys
  keysToPreserve.forEach((key) => {
    if (preservedValues[key] !== null) {
      localStorage.setItem(key, preservedValues[key] as string);
    }
  });
}
